import {
  differenceInSeconds,
  format,
  formatDistanceToNowStrict,
} from 'date-fns'

/** Calendar day only, e.g. Sep 8, 2026 */
export function formatChargesDate(value: string | Date): string {
  return format(new Date(value), 'MMM d, yyyy')
}

/** Absolute datetime without seconds, e.g. Sep 8, 2026, 6:00 PM */
export function formatChargesDateTime(value: string | Date): string {
  return format(new Date(value), 'MMM d, yyyy, h:mm a')
}

/** Relative time that never uses the "seconds" unit. */
export function formatChargesRelative(value: string | Date): string {
  const date = new Date(value)
  if (Math.abs(differenceInSeconds(new Date(), date)) < 60) {
    return 'just now'
  }
  return formatDistanceToNowStrict(date, { addSuffix: true })
}
